const mutations = {
  SET_SIMULATION_LOCATION_GROUPS(state, locationGroupMap) {
    state.locationGroupMap = locationGroupMap
  },
  SET_LOCATION_LIST_COUNT(state, locationListCount) {
    state.locationListCount = locationListCount
  },
}

export default mutations
